import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import KProgress from 'k-progress'
import VueCarousel from 'vue-carousel'
import responsive from 'vue-responsive'
import VueSession from 'vue-session'

Kakao.init("45f87c038ea0ea3b3a05d0968cb18fb2");

Vue.config.productionTip = false
Vue.component('v-icon', Icon)
Vue.component('k-progress', KProgress)

Vue.use(VueCarousel);
Vue.use(responsive);
Vue.use(VueSession, {
  persist: true
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
